import * as React from 'react';
import { T } from '../../../Translations';
import CompleteSegmentIcon from '../../Cutesies/CompleteSegmentIcon';
import CurrentSegmentIcon from '../../Cutesies/CurrentSegmentIcon';
import OutlineLockIcon from '../OutlineLockIcon';
import * as style from '../style.module.css';

// Tucked behind a hover/focus "key" trigger so it doesn't take permanent space at the top
// of the outline. Each legend icon matches the icon the segment renders for that state;
// "You're here" isn't listed because its pill carries the label.
const OutlineLegend: React.FC = () => (
  <div className={style.legendWrap}>
    <button
      type="button"
      className={style.legendTrigger}
      aria-label="Overview key"
      data-test-outline-legend-trigger={true}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true}>
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
        <path d="M12 11.5v4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="7.75" r="1.25" fill="currentColor" />
      </svg>
    </button>
    <ul className={style.legend} role="tooltip" data-test-outline-legend={true}>
      <li className={style.legendItem}>
        <span className={style.legendIcon}>
          <CurrentSegmentIcon />
        </span>
        <span className={style.legendLabel}>
          <T kind="Resume" />
        </span>
      </li>
      <li className={style.legendItem}>
        <span className={style.legendIcon}>
          <CompleteSegmentIcon />
        </span>
        <span className={style.legendLabel}>
          <T kind="Completed" />
        </span>
      </li>
      <li className={style.legendItem}>
        <span className={style.legendIcon}>
          <OutlineLockIcon />
        </span>
        <span className={style.legendLabel}>
          <T kind="Locked" />
        </span>
      </li>
    </ul>
  </div>
);
export default OutlineLegend;
